import { ServiceOptionType } from '@wix/ambassador-bookings-catalog-v1-service-options-and-variants/types';
export const getVariantType = serviceVariants => {
  var _serviceVariants$opti;
  return serviceVariants == null || (_serviceVariants$opti = serviceVariants.options) == null || (_serviceVariants$opti = _serviceVariants$opti.values) == null || (_serviceVariants$opti = _serviceVariants$opti[0]) == null ? void 0 : _serviceVariants$opti.type;
};
export const isStaffVariant = serviceVariants => {
  return getVariantType(serviceVariants) === ServiceOptionType.STAFF_MEMBER;
};
export const isCustomVariant = serviceVariants => {
  return getVariantType(serviceVariants) === ServiceOptionType.CUSTOM;
};
export const isDurationVariant = serviceVariants => {
  return getVariantType(serviceVariants) === ServiceOptionType.DURATION;
};
export const getStaffVariantsFromAllVariants = (service, optionsAndVariants) => {
  var _optionsAndVariants$o, _optionsAndVariants$v;
  if (!service || (optionsAndVariants == null ? void 0 : optionsAndVariants.serviceId) !== service.id) {
    return;
  }
  const staffVariants = {};
  const staffOptionId = optionsAndVariants == null || (_optionsAndVariants$o = optionsAndVariants.options) == null || (_optionsAndVariants$o = _optionsAndVariants$o.values) == null || (_optionsAndVariants$o = _optionsAndVariants$o[0]) == null ? void 0 : _optionsAndVariants$o.id;
  if (!staffOptionId || !isStaffVariant(optionsAndVariants)) {
    return;
  }
  optionsAndVariants == null || (_optionsAndVariants$v = optionsAndVariants.variants) == null || (_optionsAndVariants$v = _optionsAndVariants$v.values) == null || _optionsAndVariants$v.forEach(variant => {
    var _variant$choices;
    (_variant$choices = variant.choices) == null || _variant$choices.forEach(choice => {
      if (choice.optionId === staffOptionId) {
        staffVariants[choice.staffMemberId] = variant.price;
      }
    });
  });
  return {
    variants: staffVariants
  };
};
//# sourceMappingURL=serviceOptionsAndVariants.js.map